import { Check, Circle } from "lucide-react"
import { useEffect, useState } from "react"

const steps = [
  "Generating new image...",
  "Calling off Judgement day...",
  "Adding brand spices...",
  "Calling Sarah Conner...",
  "Cooling down servers...",
]

const CanvasImageLoader = () => {

  const [currentStep, setCurrentStep] = useState(0)
  const [completedSteps, setCompletedSteps] = useState<Set<number>>(new Set())

  useEffect(() => {
    if (currentStep >= steps.length) return

    const timer = setTimeout(() => {
      setCompletedSteps((prev) => new Set([...prev, currentStep]))

      // Only advance if not at the last step
      if (currentStep < steps.length - 1) {
        setCurrentStep((prev) => prev + 1)
      }
    }, 12000)

    return () => clearTimeout(timer)
  }, [currentStep])


  return (
    <div className="absolute z-50 w-full h-full bg-black/60 flex flex-col items-center justify-center rounded-xl overflow-hidden">

      <div className="space-y-6">
        {steps.map((step, index) => {
          const isActive = index === currentStep
          const isCompleted = completedSteps.has(index)

          return (
            <div key={index} className="flex items-center space-x-4">
              <div className="relative flex-shrink-0">
                <div
                  className={`w-8 h-8 rounded-full border-2 flex items-center justify-center transition-all duration-300 ${
                    isCompleted
                      ? "bg-purple-600 border-purple-600"
                      : isActive
                        ? "border-purple-600 bg-purple-50"
                        : "border-gray-300 bg-white"
                  }`}
                >
                  {isCompleted ? (
                    <Check className="w-4 h-4 text-white" />
                  ) : isActive ? (
                    <Circle className="w-3 h-3 text-indigo-600 fill-current animate-pulse" />
                  ) : (
                    <Circle className="w-3 h-3 text-gray-400 fill-current" />
                  )}
                </div>
                {isActive && <div className="absolute inset-0 bg-indigo-500/20 rounded-full blur-md animate-pulse" />}
              </div>

              <p
                className={`font-medium font-montserrat tracking-wide transition-colors duration-300 ${
                  isCompleted ? "text-white/60" : isActive ? "text-purple-100" : "text-gray-50"
                }`}
              >
                {step}
              </p>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default CanvasImageLoader
